import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Toast, ToastContainer } from 'react-bootstrap';
import './AdminNotifications.css';

const AdminNotificationsContext = createContext(null);

export const AdminNotificationsProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((current) => current.filter((toast) => toast.id !== id));
  }, []);

  const notify = useCallback((toast) => {
    const id = `admin-toast-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    setToasts((current) => [
      ...current,
      {
        id,
        title: toast.title ?? 'Notificación',
        message: toast.message ?? '',
        variant: toast.variant ?? 'info',
        autohide: toast.autohide ?? true,
        delay: toast.delay ?? 4000,
      },
    ]);
    return id;
  }, []);

  const contextValue = useMemo(
    () => ({
      notify,
      remove: removeToast,
    }),
    [notify, removeToast],
  );

  return (
    <AdminNotificationsContext.Provider value={contextValue}>
      {children}
      <ToastContainer className="admin-toast-container position-fixed top-0 end-0 p-3" position="top-end">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            onClose={() => removeToast(toast.id)}
            autohide={toast.autohide}
            delay={toast.delay}
            className={`admin-toast admin-toast-${toast.variant}`}
          >
            <Toast.Header closeButton>
              <strong className="me-auto">{toast.title}</strong>
            </Toast.Header>
            <Toast.Body>{toast.message}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </AdminNotificationsContext.Provider>
  );
};

AdminNotificationsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAdminNotifications = () => {
  const context = useContext(AdminNotificationsContext);
  if (!context) {
    throw new Error('useAdminNotifications must be used within an AdminNotificationsProvider');
  }
  return context;
};

